<template>
  <div v-if="position.dealList">
    <div class="urgentCon">
      <ul v-if="position.dealList.length>0">
        <li v-for="(item,index) in position.dealList" @click="showSub(index)">
          <div v-if="urgentCon=='record'" class="itemCon itemCancel">
            <span>#{{ item.pno }}</span>
            <span>{{ item.applyTime }}</span>
          </div>
          <div class="itemCon itemTit">
            <span>{{ item.symbol }}<em>#{{ item.positionId }}</em><img v-if="urgentCon=='close'" :class="{expand:activeSubIndex==index}" src="@/assets/images/template/user_arrow.png"></span>
            <p>{{ item.openTime }}</p>
          </div>
          <div class="itemCon">
            <div class="item"><p class="p_mode" :class="item.directionName=='买'?'buy':'sell'">{{ item.directionName }}{{ item.directionName=='买'?'入':'出' }}</p><span>{{ item.volume }}手</span></div>
            <div class="item"><p>止损</p><span>{{ item.stopLoss==''?'--':item.stopLoss }}</span></div>
            <div class="item"><p>止盈</p><span>{{ item.takeProfit==''?'--':item.takeProfit }}</span></div>
          </div>
          <div class="itemCon">
            <div class="item"><p class="marginRight">开仓价</p><span>{{ item.openPrice }}</span></div>
            <div class="item"><p>利息</p><span>{{ item.swap }}</span></div>
            <div class="item"><p>佣金</p><span>{{ item.commission }}</span></div>
          </div>
          <span v-if="activeSubIndex==index" class="btn" @click="positionPop(item.positionId)">平仓</span>
        </li>
      </ul>
      <noData v-else />
    </div>
    <div v-if="position.dealList.length>0" class="more" :class="moreClass" @click="clickMore"><span>{{ moreTxt }}</span></div>
    <!--平仓提醒-->
    <div v-if="isPosition&&urgentCon=='close'" class="popFixed">
      <div class="masking" @click="positionPop(0)" />
      <div class="tcCon">
        <div class="item">
          <span>平仓提醒</span>
          <p>确定要对当前订单进行平仓操作吗？</p>
        </div>
        <div class="btnCon">
          <span @click="positionPop(0)">取消</span>
          <span @click="submit">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/view/module/noData.vue'
import api from '@/plugins/api'
export default {
  name: 'Position',
  components: { noData },
  props: ['platform', 'urgentCon'],
  data() {
    return {
      isPosition: false,
      activeSubIndex: -1,
      positionId: '',
      position: '',
      positionNum: 10,
      moreTxt: ''
    }
  },
  computed: {
    moreClass: {
      get() {
        let classType = ''
        if (this.position.dealList) {
          if (this.position.dealList.length >= 10 && this.position.totalPage > 1) {
            this.moreTxt = '加载更多'
            classType = ''
          } else {
            this.moreTxt = '没有更多数据'
            classType = 'noData'
          }
          return classType
        }
      }
    }
  },
  watch: {
    platform: function() {
      this.initData()
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      const data = {
        index: 1,
        pageSize: 10,
        platform: this.platform,
        type: this.urgentCon == 'close' ? 'unChiChang' : 'chiChang'
      }
      this.positionData(data)
    },
    positionData(data) {
      api.getDealList(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          this.position = res.data.data
        }
      })
    },
    clickMore() {
      let data = {}
      if (this.moreTxt == '加载更多') {
        this.positionNum += 10
        data = {
          index: 1,
          pageSize: this.positionNum,
          platform: this.platform,
          type: this.urgentCon == 'close' ? 'unChiChang' : 'chiChang'
        }
        this.positionData(data)
      }
    },
    showSub(index) {
      if (this.urgentCon == 'close') {
        this.activeSubIndex = this.activeSubIndex == index ? -1 : index
      }
    },
    positionPop(positionId) {
      if (positionId != 0) {
        this.positionId = positionId
      }
      this.isPosition = !this.isPosition
    },
    submit() {
      const data = {
        positionId: this.positionId
      }
      api.closePosition(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          this.isPosition = false
          this.activeSubIndex = -1
          this.initData()
        }
      })
    }
  }
}
</script>
